import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WRHero } from '../components/wrinkle-relaxers/WRHero';
import { WRHowItWorks } from '../components/wrinkle-relaxers/WRHowItWorks';
import { WRTargetAreas } from '../components/wrinkle-relaxers/WRTargetAreas';
import { WRBotox } from '../components/wrinkle-relaxers/WRBotox';
import { WRDysport } from '../components/wrinkle-relaxers/WRDysport';
import { WRXeomin } from '../components/wrinkle-relaxers/WRXeomin';
import { WRSupplement } from '../components/wrinkle-relaxers/WRSupplement';
import { WRFAQ } from '../components/wrinkle-relaxers/WRFAQ';
import { WRWhyChoose } from '../components/wrinkle-relaxers/WRWhyChoose';
import { WRCTA } from '../components/wrinkle-relaxers/WRCTA';
export function WrinkleRelaxersPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2686">
      <Navigation data-id="element-2687" />
      <main data-id="element-2688">
        <WRHero data-id="element-2689" />
        <WRHowItWorks data-id="element-2690" />
        <WRTargetAreas data-id="element-2691" />
        <WRBotox data-id="element-2692" />
        <WRDysport data-id="element-2693" />
        <WRXeomin data-id="element-2694" />
        <WRSupplement data-id="element-2695" />
        <WRFAQ data-id="element-2696" />
        <WRWhyChoose data-id="element-2697" />
        <WRCTA data-id="element-2698" />
      </main>
      <Footer data-id="element-2699" />
    </div>;
}